// дескриптор для менеджеров админов
export const Admin = {
    // идентификатор дескриптора
    id: 'admin',
    title: 'admin',
    EditFbsFbo:true,
    // в данном случае описываются доступные вкладки
    items: [{id:'newClients', title: 'Новые клиенты', icon: 'newClients'}, 
        {id:'myClients', title: 'Мои клиенты', icon: 'myClients'},
        {id:'pickProducts', title: 'Забор товара', icon: 'pickProducts'},
        {id:'moveProducts', title: 'Движение товара', icon: 'moveProducts'},
        {id:'storageProducts', title: 'Хранение товара', icon: 'storageProducts'},
        {id:'transfer', title: 'Отгрузка', icon: 'transfer'},
        {id:'saveProducts', title: 'Адресное хранение', icon: 'saveProducts'},
        {id:'returns', title: 'Возвраты', icon: ''},
        {id:'fbsAdmin', title: 'FBS', icon: 'saveProducts'}
        // {id:'DealTable', title: 'Сделка', icon: 'pickProducts'}
    ],
  };

  // Дескриптор для сделки как у клиента, но что бы админ мог добавлять товар
  export const DealAdmin = {
    id: 'dealAdmin',
    title: 'Сделка',
    // бридж
    api:'productsClientBridge',
    // свойство для report table показывать ли чекбоксы на каждую строку
    showCheckboxes: false,
    // свойство для report table для расширения строки доп данными
    expanded:false,  
    items: [
      // id - путь в данных
      // title - наименование данных для отображения
      // formatter - какой форматтер применять к данным см formatters
            // {id: 'data.photo' , title: 'Фото', formatter: "imageFormatProduct"},
            // {id: 'data.title', title: 'Наименование товара', formatter: 'DefaultTypography', width: '180px'},
            { id: 'data', title: 'Товар', formatter: 'Product', width: '320px' },
            {id: 'size.title', title: 'Размер', formatter: 'DefaultTypography'},
            {id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
            {id:'size', title: 'Штрих код', formatter: "BarCode", width: '200px'},
            // {id:'qrcode', title: 'QR код', formatter: "UploadQrButton"},
            {id:'size.countQr', title: 'Кол-во загруженных QR кодов', formatter: 'DefaultTypography', width: '200px'},
            {id:'size.techTask', title: 'Техническое задание', formatter: 'UploadTechTaskButton', width:'400px'},
            {id:'countProduct', title: 'Заявленное кол-во', formatter: 'DefaultTypography'},
    ]
  };

  